import { audioSession, resumeAudioContext } from './audio-session.js';

// Web Audio only measures the microphone; it is never connected to the speakers.
export class MicrophoneLevel {
  constructor(onLevel) { this.onLevel = onLevel; this.generation = 0; }
  async start() {
    this.stop(); const generation = this.generation;
    try {
      const Context = window.AudioContext || window.webkitAudioContext;
      if (!Context || !navigator.mediaDevices?.getUserMedia) return;
      this.releaseCapture = audioSession.beginCapture();
      const context = new Context(); this.context = context;
      await resumeAudioContext(context);
      if (generation !== this.generation) return;
      const stream = await navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: true }, video: false });
      if (generation !== this.generation) { stream.getTracks().forEach(track => track.stop()); audioSession.sync(); return; }
      this.stream = stream; this.source = context.createMediaStreamSource(stream);
      this.analyser = context.createAnalyser(); this.analyser.fftSize = 1024;
      this.source.connect(this.analyser); this.samples = new Float32Array(this.analyser.fftSize);
      this.level = 0;
      for (const track of stream.getTracks()) track.onended = () => { if (generation === this.generation) this.stop(); };
      const measure = () => {
        if (generation !== this.generation) return;
        this.analyser.getFloatTimeDomainData(this.samples);
        let sum = 0;
        for (const value of this.samples) sum += value * value;
        const rms = Math.sqrt(sum / this.samples.length);
        const target = Math.max(0, Math.min(1, (20 * Math.log10(Math.max(rms, .00001)) + 55) / 45));
        this.level += (target - this.level) * (target > this.level ? .7 : .25);
        this.onLevel(this.level, true);
        this.frame = requestAnimationFrame(measure);
      };
      measure();
    } catch {
      // Speech may still work when a browser cannot share its capture device.
      if (generation === this.generation) this.stop();
    }
  }
  stop() {
    ++this.generation; cancelAnimationFrame(this.frame);
    this.stream?.getTracks().forEach(track => { track.onended = null; track.stop(); }); this.stream = null;
    this.source?.disconnect(); this.source = null;
    this.context?.close().catch(() => {}); this.context = null;
    this.releaseCapture?.(); this.releaseCapture = null;
    this.onLevel(0, false);
  }
}
